import { j as d } from "../_virtual/jsx-runtime.js";
import { c as x } from "../_virtual/compiler-runtime.js";
import { SurgeThemeContext as v } from "../hooks/theme-context.js";
import { defaultTranslationFunction as h, SurgeLocalizationContext as g } from "../hooks/localization-context.js";
import { getLocaleFromCode as j } from "../hooks/locale-map.js";
function R(p) {
  const e = x.c(11), {
    children: i,
    theme: a,
    t: u,
    locale: f
  } = p, n = a === void 0 ? "light" : a, s = u === void 0 ? h : u, c = f === void 0 ? "en-us" : f;
  let l;
  e[0] !== c ? (l = j(c), e[0] = c, e[1] = l) : l = e[1];
  const m = l;
  let t;
  e[2] !== m || e[3] !== s ? (t = {
    t: s,
    locale: m
  }, e[2] = m, e[3] = s, e[4] = t) : t = e[4];
  let o;
  e[5] !== i || e[6] !== t ? (o = /* @__PURE__ */ d.jsx(g, { value: t, children: i }), e[5] = i, e[6] = t, e[7] = o) : o = e[7];
  let r;
  return e[8] !== o || e[9] !== n ? (r = /* @__PURE__ */ d.jsx(v, { value: n, children: o }), e[8] = o, e[9] = n, e[10] = r) : r = e[10], r;
}
export {
  R as SurgeProvider
};
